/* page-faq.js — ARIA tabs for FAQ section.
 * Scans for [data-page-faq] roots, wires click + keyboard nav on [role=tab],
 * syncs the selected tab to location.hash, and restores from hash on load.
 * The accordion (<details>) inside each panel needs no JS. */
(function () {
  'use strict';

  function activateTab(root, tabId) {
    var tabs = root.querySelectorAll('[role="tab"]');
    var panels = root.querySelectorAll('[role="tabpanel"]');
    var matched = false;
    tabs.forEach(function (tab) {
      var isSelected = tab.getAttribute('data-page-faq-tab') === tabId;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      if (isSelected) matched = true;
    });
    panels.forEach(function (panel) {
      var isMatch = panel.getAttribute('data-page-faq-panel') === tabId;
      if (isMatch) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    return matched;
  }

  function focusTab(root, index) {
    var tabs = root.querySelectorAll('[role="tab"]');
    if (!tabs.length) return;
    var len = tabs.length;
    var i = ((index % len) + len) % len;
    var tabId = tabs[i].getAttribute('data-page-faq-tab');
    activateTab(root, tabId);
    tabs[i].focus();
    if (history.replaceState) {
      history.replaceState(null, '', '#' + tabId);
    } else {
      location.hash = tabId;
    }
  }

  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var id = tab.getAttribute('data-page-faq-tab');
        activateTab(root, id);
        // preventScroll: the user already chose what to click — don't let the
        // browser re-scroll the page to vertically center the tab.
        tab.focus({ preventScroll: true });
        if (history.replaceState) {
          history.replaceState(null, '', '#' + id);
        } else {
          location.hash = id;
        }
      });

      tab.addEventListener('keydown', function (e) {
        switch (e.key) {
          case 'ArrowRight':
            e.preventDefault();
            focusTab(root, idx + 1);
            break;
          case 'ArrowLeft':
            e.preventDefault();
            focusTab(root, idx - 1);
            break;
          case 'Home':
            e.preventDefault();
            focusTab(root, 0);
            break;
          case 'End':
            e.preventDefault();
            focusTab(root, tabs.length - 1);
            break;
        }
      });
    });

    var initialId = (location.hash || '').replace(/^#/, '');
    if (initialId) {
      var matched = activateTab(root, initialId);
      if (!matched) {
        var firstId = tabs[0].getAttribute('data-page-faq-tab');
        activateTab(root, firstId);
      }
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-page-faq]');
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
